import React, { useEffect, useState } from 'react';
import SystemLogsService from '../services/SystemLogsService'
import { NavLink, useParams } from 'react-router-dom';
import { FaEye } from "react-icons/fa";
import ViewData from '../modals/ViewData';
import { toast, ToastContainer } from 'react-toastify';

const RecentActivity = ({ type }) => {
    const [systemLogs, setSystemLogs] = useState({ data: [] });
    const { id } = useParams();
    const [showViewModal, setShowViewModal] = useState(false);
    const [currentLogIndex, setCurrentLogIndex] = useState(null);
    const handleShowViewModal = (index) => {
        setCurrentLogIndex(index);
        setShowViewModal(true);
    };
    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setCurrentLogIndex(null);
    };

    useEffect(() => {
        const fetchSystemLogs = async () => {
            try {
                const response = await SystemLogsService.getLogByType(type, id);
                if (response.status === 200 && response.data.success) {
                    setSystemLogs(response.data.data || []);
                }
            } catch (error) {
                console.error('Something went wrong', error);
                toast.error(error?.response?.data?.message || error?.message);
            }
        };
        fetchSystemLogs();
    }, [type, id])

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h4 className="card-header-title">Recent Activity</h4>
                </div>
                <div className="card-body overflow-auto" style={{ height: '230px', maxHeight: '230px', scrollbarWidth: 'thin'}}>
                    <div className="list-group list-group-flush list-group-activity my-n3">
                        {systemLogs.length > 0 ? (
                            systemLogs.map((log, index) => (
                                <div key={log.id}>
                                    <div className="list-group-item d-flex">
                                        <div className="row">
                                            <div className="col-auto">
                                                <div className="avatar avatar-sm">
                                                    <div className="avatar-title fs-lg bg-primary-subtle rounded-circle text-primary">
                                                        <i className="fe fe-mail"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col ms-n2">
                                                <p className="small text-gray-700 mb-0">This {log?.type} is {log?.action} by <b>{log?.user?.name}</b> at {log?.createdAt}</p>
                                            </div>
                                        </div>
                                        <NavLink to="#" onClick={(e) => {
                                            handleShowViewModal(index);
                                        }}><FaEye /></NavLink>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p colSpan="8">No activity / logs available</p>
                        )}
                        <ViewData
                            show={showViewModal}
                            onCancel={handleCloseViewModal}
                            systemLogs={systemLogs}
                            currentLogIndex={currentLogIndex}
                        />
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}

export default RecentActivity